import { types, query } from 'typed-graphqlify';
import { gql } from '@apollo/client';

export const locationAvailabilityInitQuery = gql`
  ${query({
    locations: [
      {
        id: types.string,
        organisation_id: types.string,
      },
    ],
  })}
`;
